module.exports = __webpack_public_path__ + "fca6329c.png";